import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { FiltersWidget } from "../FiltersWidget";
import { Events, eventsManager, SavaneCookie } from "@rhinov/savane-js";

export class ObjectTypeFilter implements IFilter {
    id: string;
    name?: string | null | undefined;
    type: string;
    nbColums?: number | undefined;
    source?: string | undefined;
    controller: FiltersController;
    parentGroup: FilterGroup;

    //Store history of select group tree (in order)
    static breadcrumbs: any[] = [];

    static objectFilterActivated = parseInt(SavaneCookie.getCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0));
    static objectFiltersBySizeActivated = parseInt(SavaneCookie.getCookie("Rhinov-DesignerFilter-ObjectFilterBySizeEnabled", "" + 0));

    static getInstance(parentGroup: FilterGroup): ObjectTypeFilter | null {
        if (!parentGroup.filters || parentGroup.filters.length === 0) return null;
        return parentGroup.filters.find((filter: IFilter) => filter.id === 'objectType') as ObjectTypeFilter || null;
    }

    constructor(parentGroup: FilterGroup) {
        this.parentGroup = parentGroup;
        this.id = 'objectType';
        this.name = 'Type d\'objet';
        this.type = 'objectType';
        this.controller = new FiltersController();
    }

    static objectFilters() {
        return (ObjectTypeFilter.objectFilterActivated === 1);
    };

    static objectFiltersBySize() {
        return (ObjectTypeFilter.objectFiltersBySizeActivated === 1);
    };

    static toggleObjectFiltersBySize() {
        if (!ObjectTypeFilter.objectFiltersBySize()) {
            ObjectTypeFilter.objectFiltersBySizeActivated = 1;
            SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterBySizeEnabled", "" + 1);
        }
        else {
            ObjectTypeFilter.objectFiltersBySizeActivated = 0;
            SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterBySizeEnabled", "" + 0);
        }
        eventsManager.instance.dispatch(Events.ENABLE_OBJECT_FILTERS_CHANGED, { forceUpdate: true });
    };

    static toggleObjectFilters() {
        if (!ObjectTypeFilter.objectFilters()) {
            ObjectTypeFilter.objectFilterActivated = 1;
            SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 1);
        }
        else {
            ObjectTypeFilter.objectFilterActivated = 0;
            SavaneCookie.setCookie("Rhinov-DesignerFilter-ObjectFilterEnabled", "" + 0);
        }
        eventsManager.instance.dispatch(Events.ENABLE_OBJECT_FILTERS_CHANGED, { forceUpdate: true });
    };

    static disableObjectFilter() {
        if (ObjectTypeFilter.objectFilters()) {
            ObjectTypeFilter.toggleObjectFilters();
        }
    };

    static updateObjectFiltersIcon() {
        const icon = document.querySelector('#objectFilters .fa-stack-2x') as HTMLElement | null;
        if(!icon) return;
        if (ObjectTypeFilter.objectFilters()) {
            icon.style.display = 'none';
        } else {
            icon.style.display = '';
        }
    }

    updateObjectFiltersBySizeIcon() {
        const icon = document.querySelector('#objectFiltersBySize .fa-stack-2x') as HTMLElement | null;
        if(!icon) return;
        if (ObjectTypeFilter.objectFiltersBySize()) {
            icon.style.display = 'none';
        } else {
            icon.style.display = '';
        }
    }



    searchQuery: string = '';
    selectedObjectTypes: any[] = [];

    updateSelection() {
        ($('#treeView') as any).jstree(true).destroy();
        this.selectedObjectTypes = [];
        this.instantiateTree();
    }

    convertObjectType(obj: any) {
        let children = [];
        if (obj.children && obj.children.length > 0) {
            children = obj.children.map((child: any) => this.convertObjectType(child));
        }
        const selected = FilterGroup.filters.objectType && FilterGroup.filters.objectType.some((element: any) => element._id === obj._id);
        if (selected) {
            this.selectedObjectTypes.push(obj);
        }
        return {
            'id': obj._id || '-1',
            'text': obj.name || obj.text,
            'state': {
                'opened': false,
                'selected': selected,
            },
            'children': children,
            'li_attr': {
                'style': 'text-align: left;',
            },
        };
    }

    unselectIndex(index: number) {
        let dif = 0;
        let item;
        if (this.selectedObjectTypes[index] === undefined) {
            console.error("Error: selectedObjectTypes[index] is undefined");
            return;
        };

        if (this.selectedObjectTypes.length === 0) {
            console.error("Error: selectedObjectTypes is empty");
            return;
        }
        for (let i = this.selectedObjectTypes.length - 1; i >= index; i--) {
            item = this.selectedObjectTypes[i];
            ($("#treeView") as any).jstree(true).close_all(item);
            ($('#treeView') as any).jstree(true).deselect_node(item);
            $(`#node-${item._id}-${i}`).remove();
            this.selectedObjectTypes.splice(i, 1);
            FilterGroup.filters.objectType = this.selectedObjectTypes;
            dif++;
        }
        FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
    }

    convertNodeToHtml(nodeName: string, index: number) {
        const node = this.selectedObjectTypes[index];
        if (!node) return;
        const nodeId = node._id;
        if ($(`#node-${nodeId}-${index}`)) {
            this.controller.removeEventListener('click', `close-${nodeId}-${index}`);
            this.controller.removeEventListener('click', `node-${nodeId}-${index}`);
        }
        setTimeout(() => {
            this.controller.addEventListener('click', () => {
                $(`#node-${nodeId}-${index}`).trigger('focus');
            }, `node-${nodeId}-${index}`);

            this.controller.addEventListener('click', () => {
                this.unselectIndex(index);
            }, `close-${nodeId}-${index}`);
        });
        return `
        <div class="node" id="node-${nodeId}-${index}" tabindex="-1">
            <span>${nodeName}</span>
            <div class="node-close" id="close-${nodeId}-${index}">
                <i class="fa-solid fa-xmark"></i>
            </div>
        </div>
        `;
    }

    getObjectTypesFromPath(path: string[]) {
        let objectTypes: any[] = [];
        // Always has the .name property
        let parent = FilterGroup.objectTypes.find((element: any) => element.name === path[0]);
        if (!parent) return objectTypes;
        objectTypes.push(parent);
        for (let i = 1; i < path.length; i++) {
            // Can have either .name or .text property
            parent = parent.children.find((element: any) => (element.name || element.text) === path[i]);
            if (!parent) return objectTypes;
            objectTypes.push(parent);
        }
        $('#treeViewContainer').addClass('hide-element');
        return objectTypes;
    }

    instantiateTree() {
        FilterGroup.objectTypes.sort(function(a: any, b: any) {
                            if (a.path < b.path) {
                                return (-1)
                            }
                            else {
                                return (1);
                            }
                        });

        let data = FilterGroup.objectTypes.map((element: any) => this.convertObjectType(element));
        ($('#treeView') as any).jstree({
            'core': {
                'themes': {
                    dots: true,
                    responsive: true,
                    stripes: true,
                    name: 'default-dark',
                },
                'data': [
                    ...data,
                ],
                'allow_reselect': true
            },
            'search': {

            },
            'plugins': ["search", "wholerow"],
        });

        ($('#treeView') as any).on('changed.jstree', (_e: any, data: any) => {
            const instance: any = data.instance;
            let path = instance.get_path(data.node || data.selected[0]);
            this.selectedObjectTypes = this.getObjectTypesFromPath(path);
            FilterGroup.filters.objectType = this.selectedObjectTypes;
            path = path.map((node: any, index: number) => this.convertNodeToHtml(node, index));
            $('#selectionText').html(path.join(''));
            FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            $('#searchInput').val("");
            this.searchQuery = "";
            ($('#treeView') as any).jstree(true).search("", true, true, undefined, false, true);
        });
    }

    html(): string {
        let html = `
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div class="row" style="max-width: 380px;width: 100%;margin:0 auto;">
                <span>${this.name}</span>
                <div style="display: flex;align-items: center;justify-content: center;">
                    <div id="tree-search-container">
                        <div id="selectionText"></div>
                        <input id="searchInput" type="text" placeholder="Choisissez un type"/>
                    </div>
                    <div id="objectFilters" style="cursor: pointer; padding: 0;" class="col-xs-1">
                        <span class="fa-stack">
                            <i class="fas fa-stack-1x fa-sync-alt" style="line-height: 2em;"></i>
                            '<i class="fas fa-ban fa-stack-2x" style="color:Tomato;${ObjectTypeFilter.objectFilters() ? 'display:none' : ''}"></i>
                        </span>
                    </div>
                    <div id="objectFiltersBySize" style="cursor: pointer; padding: 0;" class="col-xs-1">
                        <span class="fa-stack">
                            <i class="fas fa-stack-1x fa-ruler" style="line-height: 2em;"></i>
                            <i class="fas fa-ban fa-stack-2x" style="color:Tomato;${ObjectTypeFilter.objectFiltersBySize() ? 'display:none' : ''}"></i>'
                        </span>
                    </div>
                </div>
                <div id="treeViewContainer" class="hide-element">
                    <div id="treeView"></div>
                </div>
            </div>
        </div>
        `;

        setTimeout(() => {
            FilterGroup.loadObjectTypes().then(() => {
                if (this.parentGroup.isDestroyed) return;
                this.instantiateTree();

                this.controller.addEventListener('focus', () => {
                    $('#treeViewContainer').removeClass('hide-element');
                }, 'searchInput');

                this.controller.addEventListener('focus', () => {
                    $('#treeViewContainer').addClass('hide-element');
                }, FiltersWidget.tabParentID);

                this.controller.addEventListener('blur', () => {
                    setTimeout(() => {
                        const activeElement = document.activeElement as Element | null;
                        const viewContains = activeElement ? $('#treeViewContainer').has(activeElement).length !== 0 : false;
                        const searchContains = activeElement ? $('#tree-search-container').has(activeElement).length !== 0 : false;

                        if (!viewContains && !searchContains) {
                            // If you didn't click on the tree view or search container.
                            $('#treeViewContainer').addClass('hide-element');
                        }
                    });
                }, 'searchInput');

                this.controller.addEventListener('input', () => {
                    const searchValue = $('#searchInput').val() as string;
                    this.searchQuery = searchValue;
                    ($('#treeView') as any).jstree(true).search(searchValue, true, true, undefined, false, true);
                }, 'searchInput');

                this.controller.addEventListener('click', () => {
                    ObjectTypeFilter.toggleObjectFilters();
                    ObjectTypeFilter.updateObjectFiltersIcon();
                }, ('objectFilters'));

                this.controller.addEventListener('click', () => {
                    ObjectTypeFilter.toggleObjectFiltersBySize();
                    this.updateObjectFiltersBySizeIcon();
                }, ('objectFiltersBySize'));
            });
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        let stringFilters = "";
        let newObjectsTypes: any[] = [];

        if (FilterGroup.filters.objectType !== null && FilterGroup.filters.objectType.length > 0) {
            let res: any[] = [];

            for (let i = 0; i < FilterGroup.filters.objectType.length; i++) {
                if (newObjectsTypes.length > 0) {
                    //Verify if each element is son of the previous one, if not stop the filter now
                    if (newObjectsTypes[newObjectsTypes.length - 1].children.indexOf(FilterGroup.filters.objectType[i]) < 0) {
                        break;
                    }
                }
                else {
                    if (FilterGroup.filters.objectType[i].parent.parent !== null) {
                        break; //First elem is not a root, stop now
                    }
                }

                newObjectsTypes.push(FilterGroup.filters.objectType[i]);
                //FilterGroup._extractObjectType(filters.objectType[i], res);
            }

            if (newObjectsTypes.length > 0) {
                FilterGroup._extractObjectType(newObjectsTypes[newObjectsTypes.length - 1], res);
                if (!FilterGroup.smartSearch()) {
                    stringFilters += '&q.objectType.in=' + newObjectsTypes[newObjectsTypes.length - 1]._id + ',';

                    for (let i = 0; i < res.length; i++) {
                        if (i > 0) {
                            stringFilters += ',';
                        }
                        stringFilters += res[i];
                    }
                }
                FilterGroup.actualList = newObjectsTypes[newObjectsTypes.length - 1].children;
            }
            else {
                FilterGroup.actualList = FilterGroup.objectTypes;
            }
            //Replace with cleared filters
            FilterGroup.filters.objectType = newObjectsTypes;
        }
        else {
            FilterGroup.actualList = FilterGroup.objectTypes;
        }

        return(stringFilters);
    }

    destroy(): void {
        ($('#treeView') as any).jstree('destroy');
        this.controller.destroy();
    }
}